import { gql } from 'apollo-angular'

export default gql`
  mutation evaluateTest($phantomTestId: Int!, $answers: String!) {
    evaluateTest(data: { phantomTestId: $phantomTestId, answers: $answers }) {
      id
    }
  }
`
